























import { Component, Prop, Vue } from "vue-property-decorator";
export default class ShopMenu extends Vue {
    formInline = {
        user: "",
        region: "",
    };
}
